import gql from 'graphql-tag';

/**
 * Query for getting a list of available auth providers
 */
export const AuthenticationProvidersQuery = gql`
  query AuthenticationProvidersQuery($params: String!) {
    authenticationProviders(params: $params)
      @rest(type: "AuthenticationProviders", path: "/auth-providers?{args.params}") {
      name
      description
      redirectUrl
    }
  }
`;

export interface AuthenticationProvidersResponse {
  authenticationProviders: {
    name: string;
    description: string;
    redirectUrl: string;
  }[];
}

/**
 * Query for getting IMG and CPanel URIs.
 */
export const UriInfoQuery = gql`
  query UriInfoQuery {
    uriInfo @rest(type: "UriInfo", path: "/auth-uris") {
      cpanelUrl
      imgUrl
    }
  }
`;

export interface UriInfoResponse {
  uriInfo: {
    cpanelUrl: string;
    imgUrl: string;
  };
}
